import './../scss/global.scss';
import { Accessibility } from './components/Accessibility';
import { CustomEditor } from './components/CustomEditor';
import { Gallery } from './components/Gallery';
import { Menu } from './components/Menu';
import { MerlinForm } from './components/MerlinForm';
import { NewsletterForm } from './components/NewsletterForm';
import { PlanSwitcher } from './components/PlanSwitcher';
import { QuoteSlider } from './components/QuoteSlider';
import { ThemeFilter } from './components/ThemeFilter';
import { VideoPlayer } from './components/VideoPlayer';
import { KeepAlive } from './handlers/KeepAlive';
import { WindowEventHandler } from './handlers/WindowEventHandler';

document.addEventListener('DOMContentLoaded', () => {
  new WindowEventHandler();// Call this first to set any global properties that can be used from here on.
  new Accessibility();
  new CustomEditor();
  new KeepAlive();
  new Menu();
  new ThemeFilter();
  new VideoPlayer();
  document.querySelectorAll('.gallery-items').forEach(el => { new Gallery(el); });
  document.querySelectorAll('.merlinform').forEach(el => { new MerlinForm(el); });
  document.querySelectorAll('.section--plan').forEach(el => { new PlanSwitcher(el); });
  document.querySelectorAll('.section--quote').forEach(el => { new QuoteSlider(el); });
  document.querySelectorAll('.newsletter-form').forEach(el => { new NewsletterForm(el, false); });
  document.documentElement.classList.remove('preload');
});
